import { useState, useEffect } from 'react';
import { createBrowserRouter, RouterProvider, Navigate } from 'react-router-dom';
import ScholarshipCard from './components/Scholarship';
import Navbar from './components/Navbar';
import Camera from './components/Camera';
import Trustee from './components/Trustee';
import Feedback from './components/Feedback';
import Footer from './components/Footer';
import Logo from './components/Logo';
import ScholarshipData from './ScholarshipData';
import { useTranslation } from 'react-i18next';
import Banner from './components/Banner';
import Developer from './components/Developer';

function Home() {
  return (
    <>
      <Banner />
      <Logo />
      <Camera />
      {ScholarshipData.map((data, index) => (
        <ScholarshipCard key={index} id={`scholarship-${index}`} data={data} />
      ))}
      <Trustee />
      <Feedback />
      <Footer />
      <Developer />
    </>
  );
}

function App() {
  const { i18n } = useTranslation();
  const fontClass = i18n.language === 'en' ? 'eng-font' : 'mar-font';


  const router = createBrowserRouter([
    {
      path: '/',
      element: (
        <>
          <Navbar />
          <Home />
        </>
      ),
    },
    {
      path: '*',
      element: <Navigate to="/" />,
    },
  ]);

  return (
    <div className={fontClass}>
      
      <RouterProvider router={router} />
    </div>
  );
}

export default App;
